import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { CloudStoreAddress } from "@omni/types/api/store/cloud/shared/storeAddress.model";
import {
    ComponentsBusinessAddress,
    ComponentsCustomerAddress
} from "@omni/types/components/customer/address.model";
import { cn } from "@omni/utils/styles";
import classnames from "classnames";

import { PhoneNumber } from "@/components/General/PhoneNumber/phoneNumber.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatAddressStreetLine } from "@/utils/address/address";
import { parseCountryToISO } from "@/utils/textUtils";

type CustomerAddressProps = {
    className?: string;
    address: ComponentsCustomerAddress;
    addressType?: AddressType | null;
};

type BusinessAddressProps = {
    className?: string;
    address: ComponentsBusinessAddress;
};

type StoreAddressProps = {
    className?: string;
    storeName?: string;
    address: CloudStoreAddress;
    withPhone?: boolean;
    accentTitle?: boolean;
};

export const CustomerAddress = ({
    className,
    address,
    addressType
}: CustomerAddressProps) => (
    <div className={cn(className)}>
        {addressType === AddressType.Delivery && (
            <div>{address.addressing}</div>
        )}
        <div>{`${address.firstName} ${address.lastName}`}</div>
        <div>
            {formatAddressStreetLine(
                address.street,
                address.number,
                address.box
            )}
        </div>
        <div>{`${address.zipCode} ${address.city}`}</div>
        <div>{address.country}</div>
    </div>
);

export const BusinessAddress = ({
    className,
    address
}: BusinessAddressProps) => (
    <div className={cn(className)}>
        {address.companyName && <div>{`${address.companyName}`}</div>}
        <div>
            {formatAddressStreetLine(
                address.street,
                address.number,
                address.box
            )}
        </div>
        <div>{`${address.zipCode} ${address.city}`}</div>
        <div>{address.country}</div>
    </div>
);

export const StoreAddress = ({
    className,
    address,
    storeName,
    withPhone = false,
    accentTitle = false
}: StoreAddressProps) => {
    const { t } = useGranite();

    return (
        <div className={cn(className)}>
            <div
                className={classnames({
                    "font-weight-bold": accentTitle
                })}
            >
                {storeName}
            </div>
            <div>
                {formatAddressStreetLine(
                    address.streetName,
                    address.streetNumber,
                    address.poBox
                )}
            </div>
            <div>{`${address.postalCode} ${address.town}`}</div>
            <div>{address.country}</div>
            {withPhone && address.phone1 && (
                <div>
                    {`${t("general.phone")} `}
                    <PhoneNumber
                        asLink={true}
                        ISOcountryCode={parseCountryToISO(address.country)}
                        phoneNumber={address.phone1}
                    />
                </div>
            )}
        </div>
    );
};
